import { Component, inject } from '@angular/core';
import { MsalProviderWrapperComponent } from '../../components/msal-provider-wrapper/msal-provider-wrapper.component';
// eslint-disable-next-line boundaries/element-types
import { MainShellComponent } from '../main-shell/main-shell.component';
import { AppStore } from '@app/stores/app/app.store';

@Component({
    selector: 'app-authorized-shell-component',
    imports: [MsalProviderWrapperComponent, MainShellComponent],
    templateUrl: './authorized-shell-component.html',
    styleUrl: './authorized-shell-component.scss',
})
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class AuthorizedShellComponent {
    private appStore = inject(AppStore);
    isMF = this.appStore.isMF;
}
